import Component from "@glimmer/component";
import { arg } from "glesys-controlpanel/utils/arg";
import { array, bool, func, object, oneOfType } from "prop-types";
import { Task, restartableTask } from "ember-concurrency";
import { modifier } from "ember-modifier";

import Skeleton from "glesys-controlpanel/components/skeleton";

export default class DataLoader extends Component {
  @arg(oneOfType([func, array, object]).isRequired) load;
  @arg(bool) useLoadingSkeleton = true;
  @arg(bool) useLastSuccessfulValue = false;

  get isLoading() {
    return this.task.isRunning || (this.load instanceof Task && this.load.isRunning);
  }

  get showLastSuccessfulValue() {
    return this.useLastSuccessfulValue && Boolean(this.task.lastSuccessful);
  }

  loadData = modifier(async () => {
    this.task.perform(this.load);

    return () => this.task.cancelAll();
  });

  task = restartableTask(async (promise) => {
    switch (true) {
      case promise instanceof Task:
        return await promise.linked().perform();
      case typeof promise === "function":
        return await promise();
      case Array.isArray(promise):
        return await Promise.all(promise);
      default:
        return await promise;
    }
  });

  <template>
    <div {{this.loadData}} ...attributes>
      {{#if (has-block)}}
        {{#if this.isLoading}}
          {{#if (has-block "loading")}}
            {{yield to="loading"}}
          {{else if this.showLastSuccessfulValue}}
            {{yield this.task.lastSuccessful.value this.isLoading}}
          {{else if this.useLoadingSkeleton}}
            <Skeleton data-test-data-loader-skeleton />
          {{else}}
            {{yield}}
          {{/if}}
        {{else if this.task.last.isError}}
          {{yield this.task.last.error to="error"}}
        {{else if this.task.last.isSuccessful}}
          {{yield this.task.last.value this.isLoading}}
        {{/if}}
      {{/if}}
    </div>
  </template>
}
